export default "__VITE_ASSET__vdSCpqfS__"